import * as h2Api from '../../h2Api'

export const LIST = 'ADMIN_CERTIFICATION_LIST'
export const TOGGLE_PROMOTION = 'ADMIN_CERTIFICATION_TOGGLE_PROMOTION'

export const list = (page = 1) => dispatch => {
  return dispatch(
    h2Api.get(`/profiles/admin/certification/list?page=${page}`)({ type: LIST })
  )
}

export const togglePromotion = profile => dispatch => {
  return dispatch(
    h2Api.post(`/profiles/admin/togglePromotion/${profile.id}`, {
      toggleTo: !profile.promoted
    })({ type: TOGGLE_PROMOTION, profileId: profile.id })
  )
}
